import {
  saveRecipe as saveRecipeService,
  createCuisine as createCuisineService,
  createMeasurement as createMeasurementService,
  getIngredients as getIngredientsService,
} from "../services/RecipeService";
import {
  barcodeService,
  getPartialResult,
} from "../services/AutocompleteService";
import { getBarcode } from "../services/ContributeService";
import { createActionThunk } from "redux-thunk-actions";
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  RECIPE_ADD_ITEM,
  RECIPE_EDIT_SELECTED,
  RECIPE_SAVE_ITEM,
  RECIPE_DELETE,
  RECIPE_SAVE,
  GET_RECIPE,
  RECIPE_CLEAR,
  RECIPE_CREATE_CUISINE,
  RECIPE_CREATE_MEASUREMENT,
  SEARCH_INGREDIENTS,
  SEARCH_RECIPES,
  COMMIT_TYPED_RECIPE_NAME,
  ON_CHANGE_INGREDIENTFORM,
  ON_CHANGE_MYRECIPENTFORM,
  INGREDIENT_OPTION_SELECTED,
  INGREDIENT_KIT_SELECTED,
  INGREDIENT_KIT_ADDED,
  INGREDIENT_KIT_UPDATED,
  RECIPE_CATEGORY_SELECTED,
  RECIPE_TO_BODYMAP,
  RECIPE_FROM_BODYMAP,
  SELECTED_CATEGORY,
  REPLACE_OR_ADD_RECIPE,
  // RECIPE_UPDATE_DUPLICATE_ITEM,
  RECIPE_BARCODE_READ,
  RECIPE_BARCODE_READ_IMG,
  UPDATE_RECIPE_NAME,
  PARTIAL_RESULT_FOUND,
  GET_RECIPE_DETAIL,
  ON_CHANGE_ALERT_STATUS,
  RESET_ID,
  ADD_GREY_UPC_ITEM_NAME_FIELD,
  SET_HHMM_MODE,
  RESET_CONTRIBUTE_ALERT_STATE,
} from "./constant";
import { submit, reset } from "redux-form";

let typedCommitTimer = null;
let waitUntilFinishedInterval = null;

const TYPED_COMMIT_DELAY_MS = 10000;  // Waiting time after suggestion list appears with no further typing before committing the baseline
const POLL_INTERVAL_MS = 150;        // Time interval to check if suggestion list appeared (i.e., check every 150ms)
const MAX_WAIT_MS = 600000; // Max waiting time for backend response -- Safety cap: if no backend response (network error, component unmounted, etc.)

const formInitialization = (id, cat) => {
  return (dispatch) => {
    Promise.all([id, cat]);
  };
};
const saveClicked = () => {
  return (dispatch) => {
    dispatch(submit("formRecipeIngredient"));
  };
};

const addIngredientItem = (item, duplicate) => {
  return (dispatch) => {
    dispatch({
      type: RECIPE_ADD_ITEM,
      item: item,
      duplicate,
    });
    dispatch(reset("formRecipeIngredient"));
  };
};

const editIngredientItem = (index) => {
  return (dispatch) => {
    dispatch({
      type: RECIPE_EDIT_SELECTED,
      index: index,
    });
    dispatch(reset("formRecipeIngredient"));
  };
};

const getIngredients = (recipe, status) => {
  return async (dispatch) => {
    dispatch({
      type: GET_RECIPE,
      item: recipe,
      status,
    });
  };
};
const loadIngredients = (recipe) => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(GET_RECIPE),
    });
    const data = await getIngredientsService(recipe);
    dispatch({
      type: GET_RECIPE,
      item: data,
    });
  };
};

const saveIngredientItem = (item) => {
  return (dispatch) => {
    dispatch({
      type: RECIPE_SAVE_ITEM,
      item: item,
    });
    dispatch(reset("formRecipeIngredient"));
  };
};

const deleteIngredientItem = (item) => {
  return (dispatch) => {
    dispatch({
      type: RECIPE_DELETE,
      item: item,
    });
    dispatch(reset("formRecipeIngredient"));
  };
};
const resetId = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_ID,
    });
  };
};

const saveRecipe = (recipe, callback, id="") => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(RECIPE_SAVE),
      item: recipe,
    });
    try {
      await saveRecipeService(recipe, id);
      callback();
      dispatch({
        type: getSucceeded(RECIPE_SAVE),
      });
    } catch (e) {
      return dispatch({ type: getFailed(RECIPE_SAVE), error: e });
    }
  };
};

const categorySelected = (e) => {
  return (dispatch) => {
    dispatch({
      type: RECIPE_CATEGORY_SELECTED,
      value: e,
    });
  };
};
const saveClickedRecipe = () => {
  localStorage.removeItem("logoutWithoutSaveRegimen");
  localStorage.removeItem("logoutWithoutSaveRecipe");
  return (dispatch) => {
    dispatch(submit("formRecipe"));
  };
};

const clearRecipe = () => {
  return (dispatch) => {
    dispatch({
      type: RECIPE_CLEAR,
    });
    dispatch(reset("formRecipe"));
    dispatch(reset("formRecipeIngredient"));
  };
};
const getRecipeDetail = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_RECIPE_DETAIL,
      payload: data,
    });
  };
};

const createCuisine = createActionThunk(RECIPE_CREATE_CUISINE, (cuisine) =>
  createCuisineService(cuisine)
);

const createMeasurement = createActionThunk(
  RECIPE_CREATE_MEASUREMENT,
  (measurement) => createMeasurementService(measurement)
);

const searchIngredientOptions = (
  key,
  crossClicked,
  contributeRedirectionAlert
) => {
  key = key;
  return async (dispatch) => {
    let data = [];
    dispatch({
      type: SEARCH_INGREDIENTS,
      //item: data,
      recipe: key,
      crossClicked,
      contributeRedirectionAlert,
    });
  };
};

const startsearchRecipeOptions = () => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(SEARCH_RECIPES)
    });
  }
}

// Check if Add or Replace prompt is open
const isAddReplacePromptOpen = (uiCtx) => {
  const a = uiCtx && uiCtx.replaceAlert;
  return !!(a && a.state && a.state.showAlert === true);
};

const searchRecipeOptions = (key, uiCtx = {}) => {
  return async (dispatch, getState) => {
    // 1) update search + form name as user types
    dispatch({
      type: SEARCH_RECIPES,
      recipe: key,
    });

    // Kill any pending timers from the previous keystroke
    if (typedCommitTimer) { clearTimeout(typedCommitTimer); typedCommitTimer = null; }
    if (waitUntilFinishedInterval) { clearInterval(waitUntilFinishedInterval); waitUntilFinishedInterval = null; }

    const startTs = Date.now();

    // Start a waiter that will only begin the debounce AFTER suggestions are done loading
    waitUntilFinishedInterval = setInterval(() => {
      const s = getState().recipe;
      if (!s) return;

      // stop waiting if prompt opens or we waited too long
      if (isAddReplacePromptOpen(uiCtx) || Date.now() - startTs > MAX_WAIT_MS) {
        clearInterval(waitUntilFinishedInterval);
        waitUntilFinishedInterval = null;
        return;  // never start debounce
      }

      // Suggestions not finished yet — keep waiting
      if (s.isSuggestLoading || s.lastSuggestLoadedAt < startTs) return;

      // Suggestions finished — start the actual debounce
      clearInterval(waitUntilFinishedInterval);
      waitUntilFinishedInterval = null;

      // Re-read current value; bail if changed since this keystroke
      const typedNow = (s.recipeForm && s.recipeForm.recipe) || "";
      if (!typedNow || typedNow !== key) return;

      // If a selection exists, do not start a typed commit
      const idAtDebounceStart = s.recipeForm && s.recipeForm._id;
      if (idAtDebounceStart) {
        return;
      }

      typedCommitTimer = setTimeout(() => {
        const s2 = getState().recipe;
        if (!s2) return;

        // if the prompt is open (opened via onSelect), do not dispatch COMMIT_TYPED_RECIPE_NAME
        if (isAddReplacePromptOpen(uiCtx)) {
          return;
        }
        
        const latest = (s2.recipeForm && s2.recipeForm.recipe) || "";
        const idNow  = s2.recipeForm && s2.recipeForm._id;
        const baseline = s2.recipeNameBaseline || "";
        const normalize = (x) => String(x || "").replace(/\s+/g, " ").trim().toLowerCase();

        if (!latest.trim()) return;
        if (latest !== key) return; // user kept typing
        if (idNow) {
          return;
        }
        if (normalize(latest) === normalize(baseline)) {
          return;
        }


        dispatch({ type: COMMIT_TYPED_RECIPE_NAME, name: latest });
      }, TYPED_COMMIT_DELAY_MS);
    }, POLL_INTERVAL_MS);
  };
};

const endsearchRecipeOptions = () => {
  return async (dispatch) => {
    dispatch({
      type: getEnded(SEARCH_RECIPES)
    });
  }
}
const commitTypedRecipeName = (name) => (dispatch, getState) => {
  const s = getState().recipe;
  if (!s || s.replaceAlert) return;

  const typedNow = (s.recipeForm && s.recipeForm.recipe) || "";
  const idNow    = s.recipeForm && s.recipeForm._id;
  const baseline = s.recipeNameBaseline || "";
  const normalize = (x) => String(x || "").replace(/\s+/g, " ").trim().toLowerCase();

  if (!typedNow.trim()) return;     // nothing to commit
  if (typedNow !== name) return;          // stale blur value
  if (idNow) return; // selection active → don't convert to typed-baseline
  if (normalize(typedNow) === normalize(baseline)) return; // no real change

  dispatch({ type: COMMIT_TYPED_RECIPE_NAME, name: typedNow });
};
const onChangeIngredientForm = (e) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_INGREDIENTFORM,
      event: e,
    });
  };
};
const onChangeRecipeForm = (e) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_MYRECIPENTFORM,
      event: e,
    });
  };
};
const IngredientOptionSelected = (data) => {
  if (data && data.items) {
    return (dispatch) => {
      dispatch({
        type: INGREDIENT_KIT_SELECTED,
        item: data,
      });
    };
  } else {
    return (dispatch) => {
      dispatch({
        type: INGREDIENT_OPTION_SELECTED,
        item: data,
      });
    };
  }
};

const IngredientOptionAdded = () => {
  return (dispatch) => {
    dispatch({
      type: INGREDIENT_KIT_ADDED,
    });
  };
};

const IngredientOptionUpdated = (index) => {
  return (dispatch) => {
    dispatch({
      type: INGREDIENT_KIT_UPDATED,
      index,
    });
    dispatch(reset("formRecipeIngredient"));
  };
};

const bodyMapClicked = () => {
  return (dispatch) => {
    dispatch({
      type: RECIPE_TO_BODYMAP,
    });
  };
};
const fromBodyMap = () => {
  let bodySymptom = localStorage.getItem("bodyMapSymptom");

  return (dispatch) => {
    dispatch({
      type: RECIPE_FROM_BODYMAP,
    });
    if (bodySymptom !== "cancel") {
      bodySymptom = JSON.parse(bodySymptom);
      dispatch({
        type: INGREDIENT_OPTION_SELECTED,
        item: bodySymptom,
      });
    }
  };
};
const selectedCategory = (value) => {
  return async (dispatch) => {
    dispatch({
      type: SELECTED_CATEGORY,
      value,
    });
  };
};
const replaceOrAddRecipe = (status, recipe) => {
  return async (dispatch) => {
    dispatch({
      type: REPLACE_OR_ADD_RECIPE,
      status,
      recipe,
    });
  };
};
const updateRecipeName = (recipeName, flag, fullName, id = "") => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_RECIPE_NAME,
      recipeName,
      flag,
      fullName,
      id
    });
  };
};

// const updateDuplicateItem = (item) => {
//   return async (dispatch) => {
//     dispatch({
//       type: RECIPE_UPDATE_DUPLICATE_ITEM,
//       item,
//     });
//   };
// };

export const barcodeSearch = (val, cat, partial, preloadedData = null) => {
  return async (dispatch) => {
    let category = cat === "999" ? "02" : cat;

    dispatch({
      type: getStarted(RECIPE_BARCODE_READ),
    });
    try {
      if (partial) {
        let data = preloadedData ? preloadedData : await barcodeService(val, category);
        if (data.message) {
          //throw data.message;
          alert(data.message);
        } else {
          data = data;
        }
        const needsMealDetail =
          ([category].includes(data.category) &&
            (data.is_ref ||
              (!data.is_ref &&
                ((!data.is_own &&
                  !data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                  (data.is_own &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                  (data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt))))) ||
          (!data.is_ref &&
            ((!data.is_own &&
              data.is_history &&
              data.number_of_contribute >= 4 &&
              !data.show_prompt) ||
              (data.is_own &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt) ||
              (data.is_history &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt)));
        dispatch({
          type: getSucceeded(RECIPE_BARCODE_READ),
          data: data,
        });
        if (needsMealDetail) {
          dispatch({
            type: INGREDIENT_OPTION_SELECTED,
            item: data,
          });
        }
      } else {
        let data;
        let partialSearch = await getPartialResult(val, category);

        if (partialSearch.length == 1 && partialSearch[0].upc === val) {
          data = await barcodeService(partialSearch[0].upc, category);
          if (data.message) {
            //throw data.message;
            alert(data.message);
          } else {
            data = data;
          }

          const needsMealDetail =
            ([category].includes(data.category) &&
              (data.is_ref ||
                (!data.is_ref &&
                  ((!data.is_own &&
                    !data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                    (data.is_own &&
                      data.number_of_contribute >= 4 &&
                      !data.show_prompt) ||
                    (data.is_history &&
                      data.number_of_contribute >= 4 &&
                      !data.show_prompt))))) ||
            (!data.is_ref &&
              ((!data.is_own &&
                data.is_history &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt) ||
                (data.is_own &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                (data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt)));

          dispatch({
            type: getSucceeded(RECIPE_BARCODE_READ),
            data: data,
            partialSearch,
          });
          if (needsMealDetail) {
            dispatch({
              type: INGREDIENT_OPTION_SELECTED,
              item: data,
            });
          }
        } else {
          if (partialSearch.length === 0) {
            dispatch({
              type: getFailed(PARTIAL_RESULT_FOUND),
              upc: val,
            });
          } else {
            dispatch({
              type: getSucceeded(PARTIAL_RESULT_FOUND),
              partialSearch,
            });
          }
        }
      }
    } catch (e) {
      dispatch({
        type: getFailed(RECIPE_BARCODE_READ),
        upc: val,
      });
      console.log(e);
      // alert("Item not found");
    }
    dispatch({
      type: getEnded(RECIPE_BARCODE_READ),
    });
  };
};
const onSubmitUpcImage = (image, cat = "02") => {
  return async (dispatch) => {
    let category = cat === "999" ? "02" : cat;
    dispatch({
      type: getStarted(RECIPE_BARCODE_READ_IMG),
    });
    try {
      const barcodeNum = await getBarcode(image);
      dispatch({
        type: getSucceeded(RECIPE_BARCODE_READ_IMG),
        data: barcodeNum,
      });
      dispatch({
        type: getStarted(RECIPE_BARCODE_READ),
      });
      try {
        let data = await barcodeService(barcodeNum.barcode, category);
        if (data.message) {
          //throw data.message;
          alert(data.message);
        } else {
          data = data;
        }

        const needsMealDetail =
          ([category].includes(data.category) &&
            (data.is_ref ||
              (!data.is_ref &&
                ((!data.is_own &&
                  !data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                  (data.is_own &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                  (data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt))))) ||
          (!data.is_ref &&
            ((!data.is_own &&
              data.is_history &&
              data.number_of_contribute >= 4 &&
              !data.show_prompt)));

          // (!data.is_ref &&
          //   ((!data.is_own &&
          //     data.is_history &&
          //     data.number_of_contribute >= 4 &&
          //     !data.show_prompt) ||
          //     (data.is_own &&
          //       data.number_of_contribute >= 4 &&
          //       !data.show_prompt) ||
          //     (data.is_history &&
          //       data.number_of_contribute >= 4 &&
          //       !data.show_prompt)));
        dispatch({
          type: getSucceeded(RECIPE_BARCODE_READ),
          data: data,
        });
        if (needsMealDetail) {
          dispatch({
            type: INGREDIENT_OPTION_SELECTED,
            item: data,
          });
        }
      } catch (e) {
        dispatch({
          type: getFailed(RECIPE_BARCODE_READ),
          upc: barcodeNum.barcode,
          message: e.message && e.message === "" ? "" : false,
        });
        // alert("Item not found");
      }
      dispatch({
        type: getEnded(RECIPE_BARCODE_READ),
      });
    } catch (error) {
      dispatch({
        type: getFailed(RECIPE_BARCODE_READ_IMG),
        date: error,
      });
    }
  };
};

const onChangeAlertStatus = (item) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ON_CHANGE_ALERT_STATUS,
        data: item,
      });
    } catch (error) {}
  };
};
const addGreyUPCToItemNameField = (barcode) => ({
  type: ADD_GREY_UPC_ITEM_NAME_FIELD,
  payload: barcode,
});
const setHHMMMode = (value) => ({
  type: SET_HHMM_MODE,
  value,
});
const resetContributeAlertState = () => ({
  type: RESET_CONTRIBUTE_ALERT_STATE,
});


export default {
  formInitialization,
  // addClicked,
  saveClicked,
  addIngredientItem,
  editIngredientItem,
  saveIngredientItem,
  deleteIngredientItem,
  resetId,
  saveRecipe,
  clearRecipe,
  getRecipeDetail,
  getIngredients,
  createCuisine,
  createMeasurement,
  saveClickedRecipe,
  searchIngredientOptions,
  searchRecipeOptions,
  onChangeIngredientForm,
  onChangeRecipeForm,
  IngredientOptionSelected,
  IngredientOptionAdded,
  IngredientOptionUpdated,
  loadIngredients,
  categorySelected,
  bodyMapClicked,
  fromBodyMap,
  selectedCategory,
  replaceOrAddRecipe,
  updateRecipeName,
  // updateDuplicateItem,
  barcodeSearch,
  onSubmitUpcImage,
  onChangeAlertStatus,
  addGreyUPCToItemNameField,
  setHHMMMode,
  resetContributeAlertState,
  commitTypedRecipeName,
  startsearchRecipeOptions,
  endsearchRecipeOptions,
};



// WEBPACK FOOTER //
// ./src/actions/recipeActions.js